<template>
  <div>
    <h3 class="mt-4 text-center">{{ $t('pages.campaign.campaign_summary.title') }}</h3>
    <b-row>
      <b-col sm="6" class="place-center">
        <lottie :options="defaultOptions" :width="300"></lottie>
      </b-col>
      <b-col sm="6">
        <div class="mt-5">
          <p class="text-muted font-size-12">
            {{ $t('pages.campaign.campaign_summary.campaign_name') }} : <strong>TEST</strong>
          </p>
          <ul class="mt-3 verti-timeline list-unstyled">
            <li class="event-list">
              <div class="event-timeline-dot">
                <i class="bx bx-right-arrow-circle"></i>
              </div>
              <div class="media">
                <div class="me-3">
                  <i class="mdi mdi-calendar-arrow-right h2 text-primary"></i>
                </div>
                <div class="media-body">
                  <div>
                    <p class="text-muted mt-1">
                      {{
                        $t('pages.campaign.campaign_summary.time_info', {
                          afterDay: finalModel.afterDay,
                          afterThis: orderStatusName(finalModel.afterThis),
                          time: finalModel.time
                        })
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li class="event-list">
              <div class="event-timeline-dot">
                <i class="bx bx-right-arrow-circle"></i>
              </div>
              <div class="media">
                <div class="me-3">
                  <i class="mdi mdi-account-arrow-right-outline h2 text-primary"></i>
                </div>
                <div class="media-body">
                  <div>
                    <p class="text-muted mt-1">
                      {{
                        $t('pages.campaign.campaign_summary.purchase_info', {
                          purchaseCount: finalModel.purchaseCount,
                        })
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li class="event-list">
              <div class="event-timeline-dot">
                <i class="bx bx-right-arrow-circle"></i>
              </div>
              <div class="media">
                <div class="me-3">
                  <i class="mdi mdi-file-send-outline h2 text-primary"></i>
                </div>
                <div class="media-body">
                  <div>
                    <p class="text-muted mt-1">
                      {{ $t('pages.campaign.campaign_summary.asin_info') }}
                    </p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </b-col>
    </b-row>
    <b-row align-h="end">
      <b-col sm="6" class="mb-2 mt-4">
        <div v-if="finalModel.includeFilters && finalModel.includeFilters.length > 0
         || finalModel.excludeFilters && finalModel.excludeFilters.length > 0">
          <p class="text-muted font-size-12">
            {{ $t('pages.campaign.campaign_summary.asin_filter') }}:
          </p>
          <div class="mb-2">
            <span><i class="mdi mdi-checkbox-blank-circle text-success"></i>
               {{ $t('pages.campaign.campaign_summary.include') }}
            </span>
            <span><i class="mdi mdi-checkbox-blank-circle text-danger"></i>
               {{ $t('pages.campaign.campaign_summary.exclude') }}
            </span>
          </div>
          <div>
            <simplebar style="max-height: 90px">
              <f-badge variant="success"
                       v-for="include in finalModel.includeFilters"
                       :key="include + 'include'">
                {{ include }}
              </f-badge>

              <f-badge variant="danger"
                       v-for="exclude in finalModel.excludeFilters"
                       :key="exclude + 'exclude'">
                {{ exclude }}
              </f-badge>
            </simplebar>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Lottie from "vue-lottie";
import emailSent from '@/assets/animations/email-sent.js'
import simplebar from "simplebar-vue";

export default {
  name: "CampaignSummary",
  props: ['finalModel'],
  components: {
    Lottie,
    simplebar
  },
  data() {
    return {
      orderStatusOptions: [
        {
          name: this.$t('pages.campaign.campaign_summary.after_this.order_date'),
          value: "order_date"
        },
        {
          name: this.$t('pages.campaign.campaign_summary.after_this.delivery_date'),
          value: "delivery_date"
        },
        {
          name: this.$t('pages.campaign.campaign_summary.after_this.shipping_date'),
          value: "shipping_date"
        },
      ],
      defaultOptions: {animationData: emailSent, loop: true},
    }
  },
  methods: {
    orderStatusName(name) {
      const orderStatus = this.orderStatusOptions.find(x => x.value === name)
      return orderStatus.name
    },
  }
}
</script>

<style scoped>

</style>